import { FC } from "react"
import { InventoryListPanel } from "../InventoryListPanel"
import styles from "./ConsumablesTab.module.scss"
import { IConsumablesTabProps } from "./types"
import { QuickSlotBelt } from "./ui/QuickSlotBelt"

export const ConsumablesTab: FC<IConsumablesTabProps> = ({
  quickSlots,
  items,
  weight,
  query,
  ctx,
  onQueryChange,
  onItemClick
}) => (
  <div className={styles.ConsumablesTab}>
    <QuickSlotBelt
      quickSlots={quickSlots}
      items={items}
      onItemClick={onItemClick}
    />
    <InventoryListPanel
      items={items}
      weight={weight}
      query={query}
      ctx={ctx}
      onQueryChange={onQueryChange}
      onItemClick={onItemClick}
    />
  </div>
)
